export const PRONTO_KEYS = {
  PRONTO: 'P', //Pronto
  BROADLINE_MULTICHANNEL: 'M', //Multi channel - Broadline & Pronto
};
export const PRONTO_ENABLED_FLAGS = [
  PRONTO_KEYS.PRONTO,
  PRONTO_KEYS.BROADLINE_MULTICHANNEL,
];
export const PRONTO_KEYS_ORDER_CONTROL = {
  KEY: 'PRONTO_MINIMUM',
  MIN_DOLLARS: 'MIN_DOLLARS',
  MIN_CASES: 'MIN_CASES',
  SHIPPING_FEE: 'SHIPPING_FEE',
};
